import { apiRequest } from "./ApiUtility";

/**
 * Send prescription to patient via email
 * Uses the sendmedicalrecord endpoint which handles prescriptions
 * @param {Object} authContext - Authentication context
 * @param {string} prescriptionId - ID of the prescription to be sent
 * @param {Array<string>} sendingModes - Array of sending modes (lowercase: ["email"])
 * @returns {Promise<Object>} API response
 */
export async function sendPrescriptionToPatient(authContext, prescriptionId, sendingModes) {
  if (!authContext) {
    return { isSuccess: false, data: "Authentication context is missing" };
  }

  if (!prescriptionId) {
    return { isSuccess: false, data: "Prescription ID is required" };
  }

  if (!sendingModes || sendingModes.length === 0) {
    return { isSuccess: false, data: "At least one sending mode is required" };
  }

  // Backend uses sendmedicalrecord endpoint for prescriptions
  const url = "/api/patientcommunication/sendmedicalrecord";
  const data = {
    recordIdToBeSent: prescriptionId,
    sendingModes: sendingModes  // Must be lowercase: ["email"]
  };

  return await apiRequest("post", url, authContext, data);
}

/**
 * Generic wrapper to send document to patient
 * Currently only supports prescriptions
 */
export async function sendDocumentToPatient(authContext, documentId, documentType, sendingModes) {
  if (!authContext) {
    return { isSuccess: false, data: "Authentication context is missing" };
  }

  if (!documentId) {
    return { isSuccess: false, data: "Document ID is required" };
  }

  if (!documentType) {
    return { isSuccess: false, data: "Document type is required" };
  }

  if (!sendingModes || sendingModes.length === 0) {
    return { isSuccess: false, data: "At least one sending mode is required" };
  }

  // Only prescription is supported
  if (documentType !== "prescription") {
    return { 
      isSuccess: false, 
      data: "Only prescriptions can be sent to patients" 
    };
  }

  return await sendPrescriptionToPatient(authContext, documentId, sendingModes);
}